import React, { useState, useEffect, useContext } from 'react';
import { Table, Form, Button, Container, Row, Col, Modal, Alert } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import '../styles/Estudios.css';

const formatCurrency = (value) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(value || 0));

const Estudios = () => {
  const { user, login, logout } = useContext(AuthContext);
  const [estudios, setEstudios] = useState([]);
  const [search, setSearch] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [editedData, setEditedData] = useState({});
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => { fetchEstudios(); }, []);

  const fetchEstudios = async () => {
    try {
      setErrorMsg('');
      const { data } = await api.get('/estudios.php');
      console.log('API /estudios.php ->', Array.isArray(data) ? data.length : data);
      setEstudios(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setErrorMsg('No se pudieron cargar los estudios. Revisa la consola (F12 → Network).');
    }
  };

  const handleSearch = (e) => setSearch(e.target.value || '');

  const handleInputChange = (e, estudioId, field) => {
    const { value } = e.target;
    setEditedData((prev) => ({
      ...prev,
      [estudioId]: { ...(prev[estudioId] || {}), [field]: value },
    }));
  };

  const handleSave = async (estudio) => {
    const updated = { ...estudio, ...(editedData[estudio.idestudio] || {}) };

    // Normaliza precio
    if (updated.precio_laboratorio !== undefined) {
      const limpio = String(updated.precio_laboratorio).replace(/[^\d.]/g, '');
      updated.precio_laboratorio = limpio === '' ? null : Number(limpio);
    }

    try {
      await api.post('/guardar_estudio.php', {
        ...updated,
        token: user?.token, // ⬅️ enviar token
      });

      alert('Estudio actualizado correctamente');

      setEstudios((prev) =>
        prev.map((e) => (e.idestudio === estudio.idestudio ? { ...e, ...updated } : e))
      );
      setEditedData((prev) => {
        const next = { ...prev };
        delete next[estudio.idestudio];
        return next;
      });
    } catch (error) {
      console.error('Error al actualizar estudio:', error);
      alert('Error al actualizar estudio.');
    }
  };

  const handleLogin = async () => {
    try {
      const { data } = await api.post('/login.php', { username, password });
      if (data?.success) {
        login(data); // guarda username/tipo/token
        setShowLoginModal(false);
        setUsername('');
        setPassword('');
      } else {
        alert('Error en el login. Verifica usuario y contraseña.');
      }
    } catch (error) {
      console.error('Error en el login:', error);
      alert('Error en el login.');
    }
  };

  // Soporta ambos nombres: 'nombreestudio' y 'nombrestudio'
  const getNombre = (est) => est?.nombreestudio ?? est?.nombrestudio ?? '';
  const filtro = (estudios || []).filter((est) =>
    getNombre(est).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Container className="mt-5">
        <Row className="mb-1">
          <Col><h1 className="text-center">Estudios</h1></Col>
          <Col className="text-right">
            {!user ? (
              <Button variant="primary" onClick={() => setShowLoginModal(true)}>Iniciar Sesión</Button>
            ) : (
              <div className="d-flex justify-content-end align-items-center gap-2">
                <span className="me-2 text-muted">Hola, {user.username} ({user.tipo})</span>
                <Button variant="outline-secondary" size="sm" onClick={logout}>Cerrar sesión</Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>

      <Container className="mt-1">
        <Row className="mb-3">
          <Col>
            <Form.Control
              type="text"
              placeholder="Buscar estudio..."
              value={search}
              onChange={handleSearch}
              className="text-center"
            />
          </Col>
        </Row>
        {errorMsg && (
          <Row className="mb-3">
            <Col><Alert variant="danger" className="text-center">{errorMsg}</Alert></Col>
          </Row>
        )}
      </Container>

      <Container className="mt-5">
        <Row>
          <Col>
            <div className="table-responsive">
              <Table responsive="md" striped bordered hover size="sm" className="estudios-table">
                <thead>
                  <tr>
                    <th>Nombre del estudio</th>
                    <th>Indicaciones</th>
                    {user && (
                      <>
                        <th className="d-none d-md-table-cell">Código</th>
                        <th className="d-none d-md-table-cell">d</th>
                        <th className="d-none d-md-table-cell">Tiempo mínimo</th>
                        <th className="d-none d-md-table-cell">Tiempo máximo</th>
                        <th className="d-none d-md-table-cell">Tipo de vial</th>
                        <th className="d-none d-md-table-cell">Precio (sin IVA)</th>
                        {user.tipo === 'admin' && <th className="d-none d-md-table-cell">Acciones</th>}
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filtro.map((estudio) => (
                    <tr key={estudio.idestudio}>
                      <td className="fw-semibold">{getNombre(estudio)}</td>
                      <td>
                        {user?.tipo === 'admin' ? (
                          <Form.Control
                            type="text"
                            value={editedData[estudio.idestudio]?.indicaciones ?? estudio.indicaciones}
                            onChange={(e) => handleInputChange(e, estudio.idestudio, 'indicaciones')}
                          />
                        ) : (
                          estudio.indicaciones
                        )}
                      </td>

                      {user && (
                        <>
                          <td className="d-none d-md-table-cell">{estudio.idestudio}</td>
                          <td className="d-none d-md-table-cell">{estudio.d}</td>
                          <td className="d-none d-md-table-cell">{estudio.tiempo_minimo}</td>
                          <td className="d-none d-md-table-cell">{estudio.tiempo_maximo}</td>
                          <td className="d-none d-md-table-cell">{estudio.tipo_vial}</td>
                          <td className="d-none d-md-table-cell">
                            {user.tipo === 'admin' ? (
                              <Form.Control
                                type="text"
                                value={editedData[estudio.idestudio]?.precio_laboratorio ?? estudio.precio_laboratorio}
                                onChange={(e) => handleInputChange(e, estudio.idestudio, 'precio_laboratorio')}
                              />
                            ) : (
                              formatCurrency(estudio.precio_laboratorio)
                            )}
                          </td>
                          {user.tipo === 'admin' && (
                            <td className="d-none d-md-table-cell">
                              <Button size="sm" onClick={() => handleSave(estudio)}>Guardar</Button>
                            </td>
                          )}
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            {!errorMsg && filtro.length === 0 && (
              <div className="text-center text-muted mb-4">No hay resultados.</div>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)}>
        <Modal.Header closeButton><Modal.Title>Iniciar Sesión</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formUsername">
              <Form.Label>Usuario</Form.Label>
              <Form.Control type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
            </Form.Group>
            <Form.Group controlId="formPassword" className="mt-2">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLoginModal(false)}>Cerrar</Button>
          <Button variant="primary" onClick={handleLogin}>Iniciar Sesión</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Estudios;
